export default {
    decryptToken: function () {
      const token = JSON.parse(localStorage.getItem('token'));
      if (token) {
        try {
          var jwt = require('jsonwebtoken');
          var tokenObject = jwt.verify(token, `${process.env.TOKEN_SECRET}`);
        } catch (err) {
          return null;
        }
        return tokenObject;
      } else {
        return null;
      }
    }
  }


// WEBPACK FOOTER //
// ./src/helpers/jwt.js